import axios from "./axios";

//Reportes
export const getEquipoByOptionsReportes = (id: number) =>
    axios.get(`/allEquipoByClienteIdOption/${id}`);

//Intervenciones
export const getClienteOptionsIntervenciones = () =>
    axios.get("/allClienteOptions");
export const getTipoEventosOptionsIntervenciones = () =>
    axios.get("allTipoEventosOptions");
export const getPlantaOptionsIntervenciones = () =>
    axios.get("/allPlantaOptions");
export const getEquiposOptionsIntervenciones = () =>
    axios.get("/allEquipoOptions");
export const getPlantaByOptionsIntervenciones = (id: number) =>
    axios.get(`/allPlantaByClienteIdOptions/${id}`);
export const getEquipoByOptionsIntervenciones = (id: number) =>
    axios.get(`/allEquipoByClienteIdOption/${id}`);
export const getEquipoPlantaByOptionsIntervenciones = (id: number) =>
    axios.get(`/allEquipo/planta/${id}/option`);

//Muestras
export const getPlantaOptionsMuestras = () =>
    axios.get("/allPlantaOptions");
export const getAllOrdenTrabajoOptionsMuestras = () =>
    axios.get(`/allOrdenTrabajoOptions`);
export const getAllEquipoOptionsMuestras = () =>
    axios.get(`/allEquipoOptions`);
export const getAllConjuntoAnalisisOptionsMuestras = () =>
    axios.get(`/allConjuntoAnalisisOptions`);
export const getAllOrdenByClienteOptionsMuestras = (id: number) =>
    axios.get(`/allOrdenByPlantaIdOptions/${id}`);
export const getAllEquipoByClienteOptionsMuestras = (id: number) =>
    axios.get(`/allEquipo/planta/${id}/option`);
export const getAllOrdenByClienteOptionMuestras = (id: number) =>
    axios.get(`/allOrdenByClienteIdOptions/${id}`);
export const getAllOrdenByPuntoTomaOptionsMuestras = (id: number) =>
    axios.get(`allPuntoTomasByClienteIdOptions/${id}`);
export const getEquipoOptionsMuestras = (id: number) =>
    axios.get(`/allEquipoByClienteIdOption/${id}`);
//Modal muestras
export const getOtOptionsPuntoDeToma = (id: number) =>
    axios.get(`/allPuntoTomasByOrdenIdOptions/${id}`);


//Info muestras
export const getEquipoOptionsPuntosDeToma = (id: number) =>
    axios.get(`/allPuntoTomasByEquipoIdOptions/${id}`);

//Punto de toma 
export const getClienteOptions = () =>
    axios.get("/allClienteOptions");
export const getEquipoOptionsPuntoToma = () =>
    axios.get("/allEquipoOptions");
export const getLubricanteOptionsPuntoToma = () =>
    axios.get("/allLubricanteOptions");
export const getComponenteOptionsPuntoToma = () =>
    axios.get("/allComponenteOptions");
export const getEquipoOptionsByClientePuntoDeToma = (id: number) =>
    axios.get(`/allEquipoByClienteIdOption/${id}`);
